import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
  persistStore,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { setupListeners } from "@reduxjs/toolkit/query";
import { baseApi } from "./api/baseApi";
import "./apis/Authentication/authApi";
import "./apis/clientConfigurationApi";
import "./apis/serviceCatalogApi";
import "./apis/rolePrivilegesApi";
import "./apis/userActivityApi";
import "./apis/billingApi";
import "./apis/serverLogsApi";
import authReducer from "./slices/authSlice";
import ssoAuthReducer from "./slices/ssoAuthSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  ssoAuth: ssoAuthReducer,
  [baseApi.reducerPath]: baseApi.reducer,
});

const persistConfig = {
  key: "hibbert-billing-root",
  version: 2,
  storage,
  blacklist: [baseApi.reducerPath],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(baseApi.middleware),
});

export const persistor = persistStore(store);

setupListeners(store.dispatch);
